import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`   

   .scroll {
      overflow: auto;
      height: 200px;
   }

   /* Better spacing for form elements */
   > div {
      margin-bottom: 12px;
   }

   .section-title {
      font-size: 13px;
      font-weight: 600;
      color: #555;
      margin: 20px 0 12px 0;
      padding-bottom: 6px;
      border-bottom: 1px solid #e0e0e0;
   }

   .row-items {
      display: flex;
      gap: 20px;
      align-items: flex-start;
      margin-top: 16px;
   }

   .row-items > *:first-child {
      flex: 2;
   }

   .row-items > *:last-child {
      flex: 1;
      max-width: 100px;
   }

   /* Switch styling improvements */
   .one {
      margin-top: 8px;
   }

   /* Polling switch - make it stand out */
   > div:has(input[type="checkbox"]):last-of-type {
      margin-top: 20px;
      padding-top: 16px;
      border-top: 1px solid #e0e0e0;
   }

   .note {
      font-size: 12px;
      color: #666;
      margin-top: 10px;
      padding: 14px;
      background: linear-gradient(135deg, #f8f9fb 0%, #f0f2f5 100%);
      border-radius: 8px;
      line-height: 1.6;
      border: 1px solid #e8eaed;
   }

   /* Input field spacing */
   input[type="text"],
   input[type="number"] {
      margin-top: 6px;
   }

   /* TextInput component - make vertical layout with spacing */
   .textInput {
      flex-direction: column !important;
      align-items: flex-start !important;
      margin-bottom: 16px;
      
      h4 {
         width: 100% !important;
         margin-bottom: 8px;
         font-size: 14px !important;
         font-weight: 500;
         color: #444;
      }
   }
`;

export const Loader = styled.span`
   width: 48px;
   height: 48px;
   border: 4px solid #e0e0e0;
   border-bottom-color: #4A90D9;
   border-radius: 50%;
   display: block;
   box-sizing: border-box;
   animation: rotation 1s linear infinite;
   margin: 40px auto;

   @keyframes rotation {
      0% {
         transform: rotate(0deg);
      }
      100% {
         transform: rotate(360deg);
      }
   }
`;